export { default as NeuralInterfaceNavigationTabs } from "./NeuralInterfaceNavigationTabs";
